// extracted by mini-css-extract-plugin
export var button = "trigger-module--button--aFSFz";
export var fadein = "trigger-module--fadein--q7Qt5";